import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style.css';

const Visibility = ({ condition, children }) => {
  if (condition == true) {
    return children;
  }
};

export default Visibility;
